module.exports = __webpack_public_path__ + "img/location.adead06d.svg";